import { AxiosPromise, AxiosStatic } from "axios";
import {
  CurrencyConversionRateBySourceCurrencyResponse,
  CurrencyConversionRatesResponse,
  CurrencyConversionRatesV2Response,
  SupportedCurrencies,
} from "../types";

export const getCurrencyConversionRates =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (): AxiosPromise<CurrencyConversionRatesResponse> =>
    await appAxios.get(`${serverURL}/currency-conversion-rates`, {
      withCredentials: true,
    });

export const getCurrencyConversionRatesV2 =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (): AxiosPromise<CurrencyConversionRatesV2Response> =>
    await appAxios.get(`${serverURL}/currency-conversion-rates/v2`, {
      withCredentials: true,
    });

export const getCurrencyConversionRatesBySourceCurrency =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (
    sourceCurrency: SupportedCurrencies
  ): AxiosPromise<CurrencyConversionRateBySourceCurrencyResponse> =>
    await appAxios.get(
      `${serverURL}/currency-conversion-rates/${sourceCurrency}`,
      {
        withCredentials: true,
      }
    );
